import {
  CompletedStatusIcon,
  ReadyIcon,
  ArchivedIcon,
  CanceledIcon,
  BilledIcon,
  FilledIcon,
  OTCIcon,
  PickupIcon,
  PartnerIcon,
  RedispatchIcon,
} from 'pages/Tracking/icons';
import classNames from 'classnames';
import styles from '../../Tracking.module.scss';
import {TrackingStatus} from 'types';

type BannerConfig = {
  icon: JSX.Element;
  title: string;
  message: string;
};

const BANNER_CONFIG: Record<TrackingStatus, BannerConfig> = {
  completed: {
    icon: <CompletedStatusIcon />,
    title: 'Order Completed',
    message: 'Your order has been completed by the pharmacy.',
  },
  billed: {
    icon: <BilledIcon />,
    title: 'Order Billed',
    message: 'Your order has been billed and is being processed.',
  },
  filled: {
    icon: <FilledIcon />,
    title: 'Order Filled',
    message: 'Your prescription has been filled and is ready.',
  },
  otc_status: {
    icon: <OTCIcon />,
    title: 'OTC Order',
    message: 'Your over-the-counter order has been processed.',
  },
  waiting_for_pickup: {
    icon: <PickupIcon />,
    title: 'Ready for Pickup',
    message:
      'Your order is ready for pickup. Please visit the pharmacy to collect it.',
  },
  ready_for_delivery: {
    icon: <ReadyIcon />,
    title: 'Ready for Delivery',
    message: 'Your order is ready and awaiting dispatch.',
  },
  delivering: {
    icon: <ReadyIcon />,
    title: 'Delivering',
    message: 'Your order is on its way to you!',
  },
  delivery_partner: {
    icon: <PartnerIcon />,
    title: 'Third-Party Delivery',
    message:
      'Your order is being delivered via a third-party delivery service.',
  },
  picked_up: {
    icon: <CompletedStatusIcon />,
    title: 'Picked Up',
    message: 'Your order has been picked up.',
  },
  delivered: {
    icon: <CompletedStatusIcon />,
    title: 'Delivered',
    message: 'Your order has been successfully delivered. Thank you!',
  },
  cancel_script: {
    icon: <CanceledIcon />,
    title: 'Script Canceled',
    message:
      'Your prescription has been canceled. Please contact support for more information.',
  },
  archive: {
    icon: <ArchivedIcon />,
    title: 'Order Archived',
    message: 'This order has been archived.',
  },
  redispatch: {
    icon: <RedispatchIcon />,
    title: 'Redelivery Scheduled',
    message:
      'Your order is scheduled for redelivery. We will attempt delivery again soon.',
  },
};

type Props = {
  status: TrackingStatus;
  attempt?: number;
};

const StatusBanner = ({status, attempt}: Props) => {
  const config = BANNER_CONFIG[status];
  const {icon, title, message} = config;

  const displayTitle =
    attempt && attempt > 1 ? `${title} (Attempt #${attempt})` : title;

  return (
    <div
      className={classNames(
        styles.statusBanner,
        styles[status.replaceAll('_', '')]
      )}
    >
      <div className={styles.statusBannerIcon}>{icon}</div>
      <h2 className={styles.statusBannerTitle}>{displayTitle}</h2>
      <p className={styles.statusBannerMessage}>{message}</p>
    </div>
  );
};

export default StatusBanner;
